import { all, call, takeEvery, take, select, put } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { deviceSetState, profileSetState } from '../actions'

const socketServerURL = `wss://v9nk4dufp2.execute-api.us-east-1.amazonaws.com/prod`
let socket

const getDevice = (state) => state.device
const getProfile = (state) => state.profile
const getDashboard = (state) => state.dashboard

const connectSocket = (token) => {
  if (socket) {
    socket.close()
  }
  socket = new WebSocket(`${socketServerURL}?token=${token}`)
  return new Promise((resolve) => {
    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          action: 'addInRoom',
          room: 'CLINIC-ADMIN',
          client_id: Math.random() * 1000000 + 1,
          content: 'Testing the Websocket API.',
        }),
      )
      resolve(true)
    }
  })
}

const createSocketChannel = (socketInstance) =>
  eventChannel((emit) => {
    const handler = (data) => {
      emit(data)
    }
    socketInstance.onmessage = handler
    socketInstance.onerror = handler
    return () => {
      socketInstance.onclose = handler
    }
  })

export function* LISTEN_TO_SOCKET({ payload }) {
  yield take
  const { jwtToken } = payload
  yield call(connectSocket, jwtToken)

  const socketChannel = yield call(createSocketChannel, socket)
  while (true) {
    const returnedData = yield take(socketChannel)
    let { data } = returnedData
    data = JSON.parse(data)
    if (data.device_id) {
      const { inventoryDevices, inventoryListingDevices } = yield select(getDevice)
      const { currentDevice } = yield select(getProfile)
      const { patientList } = yield select(getDashboard)
      inventoryDevices.map((value) => {
        if (value.device_id === data.device_id) {
          value.device_conn_status = data.status
        }

        return true
      })

      patientList.map((value) => {
        if (value.device.device_id && value.device.device_id === data.device_id) {
          value.device.device_conn_status = data.status
        }

        return true
      })
      if (inventoryListingDevices.data) {
        inventoryListingDevices.data.map((value) => {
          if (value.device_id === data.device_id) {
            value.device_conn_status = data.status
          }

          return true
        })
      }
      if (Object.keys(currentDevice).length > 0 && currentDevice.device_id === data.device_id) {
        currentDevice.device_conn_status = data.status
        yield put(profileSetState({ currentDevice }))
      }
      yield put(deviceSetState({ inventoryListingDevices, inventoryDevices }))
    }
  }
}

export function CLOSE_SOCKET() {
  if (socket) {
    socket.close()
  }
  return true
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([takeEvery('socket/LISTEN_TO_SOCKET', LISTEN_TO_SOCKET)])
}
